module.exports = __webpack_public_path__ + "img/jiaozi-1.bc9f1508.jpg";